// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ygMTY6277yZU49vFVGyA .progress {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.4rem;
}
.ygMTY6277yZU49vFVGyA .progress > :first-child {
  flex: 100% 1 1;
}
.ygMTY6277yZU49vFVGyA .progress .icon {
  flex: auto 0 0;
  font-size: 3.2em;
  margin-left: 0.4em;
  cursor: pointer;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"active": `ygMTY6277yZU49vFVGyA`,
	"progress": `progress`,
	"icon": `icon`
};
export default ___CSS_LOADER_EXPORT___;
